{
  "publicOrganizationSelectDialog": {
    "title": "Seleccione una organización",
    "subTitle": "Esta cuenta forma parte de varias organizaciones. Seleccione una para continuar."
  },
  "signUpNotAllowedDialog": {
    "title": "No se puede crear la cuenta",
    "body": "Antes de crear una cuenta con nosotros, es necesario que hable primero con su asesor. Póngase en contacto con su asesor para recibir la información y la orientación necesarias para el proceso de creación de su cuenta."
  },
  "linkExpiredDialog": {
    "title": "No se puede crear la cuenta",
    "body": "El enlace de invitación que utilizó ya no está activo. Por motivos de seguridad, estos enlaces caducan tras un tiempo determinado. Póngase en contacto con su asesor o representante de la empresa para recibir uno nuevo y continuar con la configuración de su cuenta."
  },
  "idpLogout": {
    "closeTabMessage": "Cierre de sesión completado — puede cerrar esta pestaña."
  },
  "signInErrorDialog": {
    "alreadyLinked": {
      "title": "No se puede iniciar sesión",
      "body": "Esta dirección de correo electrónico ya está vinculada a otro inicio de sesión. Póngase en contacto con soporte para obtener ayuda."
    },
    "noSignUpRole": {
      "title": "No podemos completar su inicio de sesión",
      "body": "Hay un problema con la configuración de acceso de su organización. Póngase en contacto con soporte para obtener ayuda."
    },
    "generic": {
      "title": "Algo salió mal",
      "body": "No pudimos completar su inicio de sesión. Por favor, inténtelo de nuevo."
    }
  }
}
